
<div class="item">
    <div class="item_header">
        <span class="number">{{number}}</span>
        <img src="assets/{{iconPath}}.svg" alt="tasks">
    </div>
    <p class="item_text">{{text}}</p>
</div>